import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";

import HomePage from "./pages/HomePage";
import { FilterContext } from "./context/FilterContext";

function App() {
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filters, setFilters] = useState([]);
  const [zoom, setZoom] = useState([]);

  useEffect(() => {
    ReactGA.initialize([{ trackingId: window.ATLAS_GOOGLE_ANALYTICS_ID }]);
    ReactGA.send({ hitType: "pageview", page: "/" });
    // Google Maps is loaded by ReactLeafletGoogleLayer in Map.js using the
    // GOOGLE_MAPS_API_KEY from config.js — no separate script injection needed.
  }, []);

  return (
    <div className="App">
      <FilterContext.Provider
        value={{
          filters,
          setFilters,
          appliedFilters,
          setAppliedFilters,
          zoom,
          setZoom,
        }}
      >
        <HomePage />
      </FilterContext.Provider>
    </div>
  );
}

export default App;
